<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li><a [routerLink]="['/']">Home</a></li>
      <li>
        <a [routerLink]="['/', 'artikelvorlagen', 'uebersicht']"> Artikelvorlagen </a>
      </li>
      @if (articleTemplate) {
        <li>
          {{ articleTemplate.description }}
        </li>
      } @else {
        <li>Artikelvorlage erstellen</li>
      }
    </ul>
  </div>
</div>

<div class="page-content page-frame overflow-y-auto flex flex-col gap-4">
  @if (articleTemplateId && articleTemplate) {
    <div class="page-sheet w-full max-w-7xl mx-auto grid grid-cols-3 grid-flow-dense gap-4 row-span-2 p-6">
      <section class="flex flex-col gap-2 row-span-4">
        @if (articleTemplate.image_filename) {
          <img [src]="articleImageUrl()" alt="Artikelbild" />
        } @else {
          <img src="https://placehold.co/300x200?text=Kein+Bild+hochgeladen" alt="Kein Bild hochgeladen" />
        }
        <input
          #imageInput
          type="file"
          accept="image/*"
          class="hidden"
          (change)="onImageSelected($event)"
        />
        <button
          type="button"
          class="bm-btn bm-btn-block"
          (click)="openImageUpload()"
          [disabled]="uploadingImage"
        >
          <i class="fas fa-upload"></i>{{ uploadingImage ? 'Wird hochgeladen...' : 'Artikelbild hochladen' }}
        </button>
        <button
          type="button"
          class="bm-btn bm-btn-block"
          (click)="onDeleteImage()"
          [disabled]="!articleTemplate.image_filename || uploadingImage"
        >
          <i class="fas fa-trash-alt"></i>Bild löschen
        </button>
      </section>

      <section class="bm-card bm-card-sm bm-card-border border-base-300 row-span-3">
        <div class="bm-card-body">
          <h2 class="bm-card-title bm-card-title-top bg-base-100">Artikel</h2>
          <dl class="bm-dl gap-x-2">
            <dt class="bm-dt-edit-label" (click)="editingProps.description = !editingProps.description">
              <label>Name</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.description) {
                {{ articleTemplate.description }}
              } @else {
                <hawk-shared-edit-input
                  [textValue]="articleTemplate.description"
                  [modus]="'text'"
                  (saveClicked)="updateKey('description', $event)"
                  (cancelClicked)="editingProps.description = false"
                />
              }
            </dd>

            <dt class="bm-dt-edit-label" (click)="editingProps.product_category = !editingProps.product_category">
              <label>Produkt</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.product_category) {
                {{ articleTemplate.product_category }}
              } @else {
                <hawk-shared-edit-input
                  [textValue]="articleTemplate.product_category"
                  [modus]="'text'"
                  (saveClicked)="updateKey('product_category', $event)"
                  (cancelClicked)="editingProps.product_category = false"
                />
              }
            </dd>

            <dt class="bm-dt-edit-label" (click)="editingProps.vendor = !editingProps.vendor">
              <label>Vendor</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.vendor) {
                <span>
                  {{ articleTemplate.vendor }}
                </span>
              } @else {
                <hawk-shared-edit-input
                  [textValue]="articleTemplate.vendor"
                  [modus]="'text'"
                  (saveClicked)="updateKey('vendor', $event)"
                  (cancelClicked)="editingProps.vendor = false"
                />
              }
            </dd>
            <dt class="bm-dt-edit-label" (click)="editingProps.part_nr = !editingProps.part_nr">
              <label>Part-Nr</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.part_nr) {
                <span>
                  {{ articleTemplate.part_nr }}
                </span>
              } @else {
                <hawk-shared-edit-input
                  [textValue]="articleTemplate.part_nr"
                  [modus]="'text'"
                  (saveClicked)="updateKey('part_nr', $event)"
                  (cancelClicked)="editingProps.part_nr = false"
                />
              }
            </dd>

            <dt class="bm-dt-edit-label" (click)="editingProps.end_of_life = !editingProps.end_of_life">
              <label>End of life</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.end_of_life) {
                @if (articleTemplate.end_of_life) {
                  <fa-icon [icon]="['far', 'check']" />
                }
              } @else {
                <hawk-shared-edit-input
                  [boolValue]="articleTemplate.end_of_life"
                  [modus]="'checkbox'"
                  (saveClicked)="updateKey('end_of_life', $event)"
                  (cancelClicked)="editingProps.end_of_life = false"
                />
              }
            </dd>
            <dt class="bm-dt-edit-label" (click)="editingProps.sn = !editingProps.sn">
              <label>Mit SN</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.sn) {
                @if (articleTemplate.sn) {
                  <fa-icon [icon]="['far', 'check']" />
                }
              } @else {
                <hawk-shared-edit-input
                  [boolValue]="articleTemplate.sn"
                  [modus]="'checkbox'"
                  (saveClicked)="updateKey('sn', $event ? true : false)"
                  (cancelClicked)="editingProps.sn = false"
                />
              }
            </dd>

            <dt
              class="bm-dt-edit-label"
              (click)="editingProps.eichamtsrelevant = !editingProps.eichamtsrelevant"
            >
              <label>Eichamtsrelevant</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.eichamtsrelevant) {
                @if (articleTemplate.eichamtsrelevant) {
                  <fa-icon [icon]="['far', 'check']" />
                } @else {
                  -
                }
              } @else {
                <hawk-shared-edit-input
                  [boolValue]="articleTemplate.eichamtsrelevant"
                  [modus]="'checkbox'"
                  (saveClicked)="updateKey('eichamtsrelevant', $event ? true : false)"
                  (cancelClicked)="editingProps.eichamtsrelevant = false"
                />
              }
            </dd>

            <dt class="bm-dt-edit-label" (click)="editingProps.comment1 = !editingProps.comment1">
              <label>Kommentarfeld 1</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.comment1) {
                <span>
                  {{ articleTemplate.comment1 }}
                </span>
              } @else {
                <hawk-shared-edit-input
                  [textValue]="articleTemplate.comment1"
                  [modus]="'text'"
                  (saveClicked)="updateKey('comment1', $event)"
                  (cancelClicked)="editingProps.comment1 = false"
                />
              }
            </dd>

            <dt class="bm-dt-edit-label" (click)="editingProps.comment2 = !editingProps.comment2">
              <label>ProjektID Zugehörigkeit (Komma)</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.comment2) {
                <span>
                  {{ articleTemplate.comment2 }}
                </span>
              } @else {
                <hawk-shared-edit-input
                  [textValue]="articleTemplate.comment2"
                  [modus]="'text'"
                  (saveClicked)="updateKey('comment2', $event)"
                  (cancelClicked)="editingProps.comment2 = false"
                />
              }
            </dd>

            <dt class="bm-dt-edit-label" (click)="editingProps.comment3 = !editingProps.comment3">
              <label>Kunden-ID</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.comment3) {
                <span>
                  {{ articleTemplate.comment3 }}
                </span>
              } @else {
                <hawk-shared-edit-input
                  [textValue]="articleTemplate.comment3"
                  [modus]="'text'"
                  (saveClicked)="updateKey('comment3', $event)"
                  (cancelClicked)="editingProps.comment3 = false"
                />
              }
            </dd>

            <dt
              class="bm-dt-edit-label"
              (click)="editingProps.default_owner_bentomax = !editingProps.default_owner_bentomax"
            >
              <label>Eigentümer Bentomax?<br />(Standardbelegung)</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.default_owner_bentomax) {
                @if (articleTemplate.default_owner_bentomax) {
                  <fa-icon [icon]="['far', 'check']" />
                }
              } @else {
                <hawk-shared-edit-input
                  [boolValue]="articleTemplate.default_owner_bentomax"
                  [modus]="'checkbox'"
                  (saveClicked)="updateKey('default_owner_bentomax', $event ? true : false)"
                  (cancelClicked)="editingProps.default_owner_bentomax = false"
                />
              }
            </dd>
            <dt class="bm-dt-edit-label" (click)="editingProps.bad_part_handling = !editingProps.bad_part_handling">
              <label>Bad Part Handhabung</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.bad_part_handling) {
                {{ badPartLabel(articleTemplate.bad_part_handling) }}
              } @else {
                <hawk-shared-edit-input
                  [modus]="'select'"
                  [selectValue]="articleTemplate.bad_part_handling"
                  [selectOptions]="badPartHandlingOptions"
                  (saveClicked)="updateKey('bad_part_handling', $event)"
                  (cancelClicked)="editingProps.bad_part_handling = false"
                />
              }
            </dd>
            <dt class="bm-dt-edit-label" (click)="editingProps.active = !editingProps.active">
              <label>Vorlage aktiviert</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.active) {
                @if (articleTemplate.active) {
                  <fa-icon [icon]="['far', 'check']" />
                }
              } @else {
                <hawk-shared-edit-input
                  [boolValue]="articleTemplate.active"
                  [modus]="'checkbox'"
                  (saveClicked)="updateKey('active', $event)"
                  (cancelClicked)="editingProps.active = false"
                />
              }
            </dd>
          </dl>
        </div>
      </section>

      <section class="bm-card bm-card-sm bm-card-border border-base-300 col-2">
        <div class="bm-card-body">
          <h2 class="bm-card-title bm-card-title-top bg-base-100" (click)="editingProps.info = !editingProps.info">
            Weitere Info
            <button class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost">
              <fa-icon [icon]="['far', 'edit']" />
            </button>
          </h2>

          @if (editingProps.info) {
            <hawk-shared-edit-input
              [textValue]="articleTemplate.info"
              [modus]="'textarea'"
              (saveClicked)="updateKey('info', $event)"
              (cancelClicked)="editingProps.info = false"
            />
          } @else {
            <p>{{ articleTemplate.info }}</p>
          }
        </div>
      </section>

      <section class="bm-card bm-card-sm bm-card-border border-base-300">
        <div class="bm-card-body">
          <h2 class="bm-card-title bm-card-title-top bg-base-100">Paketabmessungen</h2>
          <dl class="bm-dl gap-x-2">
            <dt class="bm-dt-edit-label" (click)="editingProps.package_height = !editingProps.package_height">
              <label>Höhe (cm)</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (editingProps.package_height) {
                <hawk-shared-edit-input
                  [numberValue]="articleTemplate.package_height"
                  [modus]="'onlyNumber'"
                  (saveClicked)="updateKey('package_height', $event)"
                  (cancelClicked)="editingProps.package_height = false"
                />
              } @else {
                {{ articleTemplate.package_height || "-" }}
              }
            </dd>

            <dt class="bm-dt-edit-label" (click)="editingProps.package_width = !editingProps.package_width">
              <label>Breite (cm)</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (editingProps.package_width) {
                <hawk-shared-edit-input
                  [numberValue]="articleTemplate.package_width"
                  [modus]="'onlyNumber'"
                  (saveClicked)="updateKey('package_width', $event)"
                  (cancelClicked)="editingProps.package_width = false"
                />
              } @else {
                {{ articleTemplate.package_width || "-" }}
              }
            </dd>

            <dt class="bm-dt-edit-label" (click)="editingProps.package_length = !editingProps.package_length">
              <label>Länge (cm)</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (editingProps.package_length) {
                <hawk-shared-edit-input
                  [numberValue]="articleTemplate.package_length"
                  [modus]="'onlyNumber'"
                  (saveClicked)="updateKey('package_length', $event)"
                  (cancelClicked)="editingProps.package_length = false"
                />
              } @else {
                {{ articleTemplate.package_length || "-" }}
              }
            </dd>

            <dt class="bm-dt-edit-label" (click)="editingProps.package_weight = !editingProps.package_weight">
              <label>Gewicht (g)</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (editingProps.package_weight) {
                <hawk-shared-edit-input
                  [numberValue]="articleTemplate.package_weight"
                  [modus]="'onlyNumber'"
                  (saveClicked)="updateKey('package_weight', $event)"
                  (cancelClicked)="editingProps.package_weight = false"
                />
              } @else {
                {{ articleTemplate.package_weight || "-" }}
              }
            </dd>
          </dl>
        </div>
      </section>

      <section class="bm-card bm-card-sm bm-card-border border-base-300">
        <div class="bm-card-body">
          <h2 class="bm-card-title bm-card-title-top bg-base-100">Bestellinformationen</h2>
          <dl class="bm-dl gap-x-2">
            <dt class="bm-dt-edit-label" (click)="editingProps.order_number = !editingProps.order_number">
              <label>Bestellnummer</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.order_number) {
                <span>
                  {{ articleTemplate.order_number || "-" }}
                </span>
              } @else {
                <hawk-shared-edit-input
                  [textValue]="articleTemplate.order_number"
                  [modus]="'text'"
                  (saveClicked)="updateKey('order_number', $event)"
                  (cancelClicked)="editingProps.order_number = false"
                />
              }
            </dd>

            <dt class="bm-dt-edit-label" (click)="editingProps.order_link = !editingProps.order_link">
              <label>Bestelllink</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (!editingProps.order_link) {
                @if (articleTemplate.order_link) {
                  <a [href]="articleTemplate.order_link" target="_blank" class="text-blue-600 hover:underline">
                    {{ articleTemplate.order_link.length > 50 ? (articleTemplate.order_link | slice:0:50) + '...' : articleTemplate.order_link }}
                    <fa-icon [icon]="['fas', 'external-link-alt']" class="ml-1 text-xs"></fa-icon>
                  </a>
                } @else {
                  -
                }
              } @else {
                <hawk-shared-edit-input
                  [textValue]="articleTemplate.order_link"
                  [modus]="'textarea'"
                  (saveClicked)="updateKey('order_link', $event)"
                  (cancelClicked)="editingProps.order_link = false"
                />
              }
            </dd>
          </dl>
        </div>
      </section>

      <section class="bm-card bm-card-sm bm-card-border border-base-300">
        <div class="bm-card-body">
          <h2 class="bm-card-title bm-card-title-top bg-base-100">Preise</h2>
          <dl class="bm-dl gap-x-2">
            <dt class="bm-dt-edit-label" (click)="editingProps.purchase_value = !editingProps.purchase_value">
              <label>Einkauf</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (editingProps.purchase_value) {
                <hawk-shared-edit-input
                  [numberValue]="articleTemplate.purchase_value"
                  [modus]="'onlyNumber'"
                  (saveClicked)="updateKey('purchase_value', $event)"
                  (cancelClicked)="editingProps.purchase_value = false"
                />
              } @else if (articleTemplate.purchase_value > 0) {
                {{ articleTemplate.purchase_value | currency: "€" }}
              } @else {
                -
              }
            </dd>

            <dt class="bm-dt-edit-label" (click)="editingProps.selling_value = !editingProps.selling_value">
              <label>Verkauf</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (editingProps.selling_value) {
                <hawk-shared-edit-input
                  [numberValue]="articleTemplate.selling_value"
                  [modus]="'onlyNumber'"
                  (saveClicked)="updateKey('selling_value', $event)"
                  (cancelClicked)="editingProps.selling_value = false"
                />
              } @else if (articleTemplate.selling_value > 0) {
                {{ articleTemplate.selling_value | currency: "€" }}
              } @else {
                -
              }
            </dd>
          </dl>
        </div>
      </section>

      <section class="bm-card bm-card-sm bm-card-border border-base-300">
        <div class="bm-card-body">
          <h2 class="bm-card-title bm-card-title-top bg-base-100">Sollwerte</h2>
          <dl class="bm-dl gap-x-2">
            <dt class="bm-dt-edit-label" (click)="editingProps.minimum_stock = !editingProps.minimum_stock">
              <label>Minimum</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (editingProps.minimum_stock) {
                <hawk-shared-edit-input
                  [numberValue]="articleTemplate.minimum_stock"
                  [modus]="'onlyNumber'"
                  (saveClicked)="updateKey('minimum_stock', $event)"
                  (cancelClicked)="editingProps.minimum_stock = false"
                />
              } @else {
                {{ articleTemplate.minimum_stock >= 0 ? articleTemplate.minimum_stock : "-" }}
              }
            </dd>
            <dt class="bm-dt-edit-label" (click)="editingProps.warning_threshold = !editingProps.warning_threshold">
              <label>Warnung bei</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (editingProps.warning_threshold) {
                <hawk-shared-edit-input
                  [numberValue]="articleTemplate.warning_threshold"
                  [modus]="'onlyNumber'"
                  (saveClicked)="updateKey('warning_threshold', $event)"
                  (cancelClicked)="editingProps.warning_threshold = false"
                />
              } @else {
                {{ articleTemplate.warning_threshold >= 0 ? articleTemplate.warning_threshold : "-" }}
              }
            </dd>
          </dl>
        </div>
      </section>

      <section class="bm-card bm-card-sm bm-card-border border-base-300">
        <div class="bm-card-body">
          <h2 class="bm-card-title bm-card-title-top bg-base-100">CQC-Felder für UniData-Projekt</h2>
          <dl class="bm-dl gap-x-2">
            <dt class="bm-dt-edit-label" (click)="editingProps.unidata_report = !editingProps.unidata_report">
              <label>Instandsetzerbericht notwendig</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (editingProps.unidata_report) {
                <hawk-shared-edit-input
                  [boolValue]="articleTemplate.unidata_report"
                  [modus]="'checkbox'"
                  (saveClicked)="updateKey('unidata_report', $event)"
                  (cancelClicked)="editingProps.unidata_report = false"
                />
              } @else if (articleTemplate.unidata_report) {
                <span class="fa fa-check"> </span>
              } @else {
                <span>-</span>
              }
            </dd>
            <dt class="bm-dt-edit-label" (click)="editingProps.unidatahdd = !editingProps.unidatahdd">
              <label>HDD ausgebaut</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (editingProps.unidatahdd) {
                <hawk-shared-edit-input
                  [boolValue]="articleTemplate.unidatahdd"
                  [modus]="'checkbox'"
                  (saveClicked)="updateKey('unidatahdd', $event)"
                  (cancelClicked)="editingProps.unidatahdd = false"
                />
              } @else if (articleTemplate.unidatahdd) {
                <fa-icon [icon]="['far', 'check']" />
              } @else {
                <span>-</span>
              }
            </dd>
            <dt class="bm-dt-edit-label" (click)="editingProps.unidata_reinstall = !editingProps.unidata_reinstall">
              <label>Reinstallation</label>
              <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                <fa-icon [icon]="['far', 'edit']" />
              </button>
            </dt>
            <dd>
              @if (editingProps.unidata_reinstall) {
                <hawk-shared-edit-input
                  [boolValue]="articleTemplate.unidata_reinstall"
                  [modus]="'checkbox'"
                  (saveClicked)="updateKey('unidata_reinstall', $event)"
                  (cancelClicked)="editingProps.unidata_reinstall = false"
                />
              } @else if (articleTemplate.unidata_reinstall) {
                <fa-icon [icon]="['far', 'check']" />
              } @else {
                <span>-</span>
              }
            </dd>
          </dl>
        </div>
      </section>

      <!-- Bestandsautomatik von der Vorlagenseite aus: dieselben Zeilen wie auf
           der Technikerseite, nur andersherum aufgezogen. -->
      <section class="bm-card bm-card-sm bm-card-border border-base-300 col-start-1 col-span-3">
        <div class="bm-card-body">
          <h2 class="bm-card-title bm-card-title-top bg-base-100">Materialbestand der Techniker</h2>
          <hawk-technician-stock-levels-grid
            [mode]="'template'"
            [articleTemplateId]="+articleTemplateId"
          />
        </div>
      </section>

      <div class="flex flex-row gap-2 justify-end col-span-3">
        <a [routerLink]="['/', 'artikelvorlagen', 'uebersicht']" class="bm-btn"> Zurück </a>
        <button (click)="onDelete()" class="bm-btn bm-btn-error"><i class="fas fa-trash-alt"></i>Löschen</button>
      </div>
    </div>
  }

  @if (newArticleTemplate) {
    <form
      class="page-sheet w-full max-w-6xl mx-auto grid grid-cols-2 gap-4"
      style="grid-template-rows: auto 1fr"
      [formGroup]="articleTemplateForm"
      (submit)="createArticleTemplate()"
    >
      <section class="bm-card bm-card-sm bm-card-border border-base-300 col-span-2">
        <div class="bm-card-body">
          <h2 class="bm-card-title">Stammdaten</h2>
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label">Bezeichnung</label>
            <input class="bm-input w-full" type="text" placeholder="Bezeichnung" formControlName="description" />

            <label class="bm-fieldset-label">Produktkategorie</label>
            <input
              class="bm-input w-full"
              type="text"
              placeholder="Produktkategorie"
              formControlName="product_category"
            />

            <label class="bm-fieldset-label">Hersteller</label>
            <input class="bm-input w-full" type="text" placeholder="Hersteller" formControlName="vendor" />

            <label class="bm-fieldset-label">Part-Nr</label>
            <input class="bm-input w-full" type="text" placeholder="Part-Nr" formControlName="part_nr" />

            <label class="bm-fieldset-label">
              <input type="checkbox" class="bm-checkbox" formControlName="sn" />Mit SN
            </label>

            <label class="bm-fieldset-label">Kommentarfeld 1</label>
            <input class="bm-input w-full" type="text" placeholder="Kommentarfeld 1" formControlName="comment1" />

            <label class="bm-fieldset-label">ProjektID Zugehörigkeit (Komma)</label>
            <input
              class="bm-input w-full"
              type="text"
              placeholder="ProjektID Zugehörigkeit (Komma)"
              formControlName="comment2"
            />

            <label class="bm-fieldset-label">Kunden-ID</label>
            <input class="bm-input w-full" type="text" placeholder="Kunden-ID" formControlName="comment3" />

            <label class="bm-fieldset-label">
              <input type="checkbox" class="bm-checkbox" formControlName="eichamtsrelevant" />Eichamtsrelevant
            </label>

            <label class="bm-fieldset-label">
              <input type="checkbox" class="bm-checkbox" formControlName="default_owner_bentomax" />Eigentümer Bentomax?
            </label>

            <label class="bm-fieldset-label">Bad Part Handhabung</label>

            <select
              class="bm-select w-full"
              placeholder="Wie soll mit BadParts umgegangen werden?"
              formControlName="bad_part_handling"
            >
              @for (handling of badPartHandlingOptions; track handling.name) {
                <option [value]="handling.id">{{ handling.name }}</option>
              }
            </select>

            <label class="bm-fieldset-label">Weitere Info</label>
            <textarea class="bm-textarea w-full" formControlName="info"></textarea>
          </fieldset>
        </div>
      </section>

      <section class="bm-card bm-card-sm bm-card-border border-base-300">
        <div class="bm-card-body">
          <h2 class="bm-card-title">Paketabmessungen</h2>
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label">Höhe (cm)</label>
            <input class="bm-input w-full" type="number" placeholder="Höhe in cm" formControlName="package_height" min="0" max="10000" />

            <label class="bm-fieldset-label">Breite (cm)</label>
            <input class="bm-input w-full" type="number" placeholder="Breite in cm" formControlName="package_width" min="0" max="10000" />

            <label class="bm-fieldset-label">Länge (cm)</label>
            <input class="bm-input w-full" type="number" placeholder="Länge in cm" formControlName="package_length" min="0" max="10000" />

            <label class="bm-fieldset-label">Gewicht (g)</label>
            <input class="bm-input w-full" type="number" placeholder="Gewicht in g" formControlName="package_weight" min="0" max="1000000" />
          </fieldset>
        </div>
      </section>

      <section class="bm-card bm-card-sm bm-card-border border-base-300">
        <div class="bm-card-body">
          <h2 class="bm-card-title">Bestellinformationen</h2>
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label">Bestellnummer</label>
            <input class="bm-input w-full" type="text" placeholder="Bestellnummer" formControlName="order_number" />

            <label class="bm-fieldset-label">Bestelllink</label>
            <textarea class="bm-textarea w-full" placeholder="https://..." formControlName="order_link"></textarea>
          </fieldset>
        </div>
      </section>

      <section class="bm-card bm-card-sm bm-card-border border-base-300">
        <div class="bm-card-body">
          <h2 class="bm-card-title">MengenSumme <small class="text-muted">aller Lager</small></h2>
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label">Minimum</label>
            <input class="bm-input w-full" type="text" placeholder="Minimum" formControlName="minimum_stock" />
            <label class="bm-fieldset-label">Warnung bei</label>
            <input class="bm-input w-full" type="text" placeholder="Warnung bei" formControlName="warning_threshold" />
          </fieldset>
        </div>
      </section>

      <section class="bm-card bm-card-sm bm-card-border border-base-300 col-2">
        <div class="bm-card-body">
          <h2 class="bm-card-title">Preise</h2>
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label">Einkaufswert</label>
            <div class="bm-input w-full">
              <input type="number" placeholder="Einkaufswert" formControlName="purchase_value" />
              <span class="bm-label">€</span>
            </div>
            <label class="bm-fieldset-label">Verkaufswert</label>
            <div class="bm-input w-full">
              <input type="number" placeholder="Verkaufswert" formControlName="selling_value" />
              <span class="bm-label">€</span>
            </div>
          </fieldset>
        </div>
      </section>

      <!-- Bestandsautomatik schon beim Anlegen: die Zeilen tragen noch keine
           Vorlagen-ID und werden erst nach dem Erstellen gespeichert. -->
      <section class="bm-card bm-card-sm bm-card-border border-base-300 col-span-2">
        <div class="bm-card-body">
          <h2 class="bm-card-title">Materialbestand der Techniker</h2>
          <hawk-technician-stock-levels-grid
            [mode]="'template'"
            [comment2]="articleTemplateForm.get('comment2')?.value"
            [comment3]="articleTemplateForm.get('comment3')?.value"
            (draftsChange)="stockLevelDrafts = $event"
          />
        </div>
      </section>

      <div class="flex flex-row gap-2 justify-end col-span-2">
        <a class="bm-btn" [routerLink]="['/', 'artikelvorlagen', 'uebersicht']">Abbrechen</a>
        <button
          class="bm-btn bm-btn-primary"
          [disabled]="articleTemplateForm.invalid || submittingTemplate"
          type="submit"
        >
          Erstellen
        </button>
      </div>
    </form>
  }
</div>
